import {IState} from './model'

export interface IPersistState {
  token?: string
  role: string
}

export const persistState = (state: IState): IPersistState => ({
  token: state.token,
  role: state.role,
})

export const hydrateState = (state: IPersistState): IState => {
  const token = state && state.token
  return {
    token: state.token,
    role: state.role,
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/login/persist.ts